<template>
  <div id="app">
    <div class="logo">
      <img src="../public/images/logo.png" alt="" />
      <span> 2026年长沙市公办小学学区划分图</span>
    </div>
    <MyMap />
    <!-- 审图号 -->
    <div class="bottomNum">
      <img src="../public/images/img.svg" alt="" />
      <span>审图号：GS(2022)3124号</span>
    </div>
    <!-- 温馨提示 -->
    <div class="info" @click="showMsg">
      <i class="el-icon-info"></i>
    </div>
    <!-- 温馨提示内容 -->
    <div class="msgCont" v-show="msgIsShow">
      <h3>
        <span>温馨提示</span>
        <i class="el-icon-close" @click="closeMsg"></i>
      </h3>
      <div class="infoCont">
        <p>
          一、公办小学学区划分由教育行政管理部门负责，有关学区划分问题以教育行政管理部门解释为准。长沙县、浏阳市、宁乡市学区划分数据在当地教育行政管理部门公布后更新。
        </p>
        <p>
          二、对公办义务教育学校学区划分及入学政策有疑问的，请咨询芙蓉区教育局基础教育科(电话84683247)、天心区教育局基础教育科（电话81830202)、湘江新区管理委员会教育局基础教育处（电话88999272）、开福区教育局基础教育处(电话82528880)、雨花区教育局基础教育处 (电话85880323） 、望城区教育局普职教育科(电话88063641） 以及长沙市教育局基础教育处（电话84899710)。
        </p>
        <p>
          三、行业办子弟小学资产为国有性质，子弟小学主要招收其举办单位职工子女。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import MyMap from "./views/MyMap.vue";

export default {
  name: "app",
  components: {
    MyMap,
  },
  data() {
    return {
      msgIsShow: false,
    };
  },
  mounted(){
    this.$store.dispatch('globalParams/getAITokenData')
  },
  methods: {
    showMsg() {
      this.msgIsShow = true;
    },
    closeMsg() {
      this.msgIsShow = false;
    },
  },
};
</script>

<style lang="scss">
html {
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 0;
  margin: 0;
  user-select: none;
  body {
    width: 100%;
    height: 100%;
    overflow: hidden;
    padding: 0;
    margin: 0;
    #app {
      font-family: "Avenir", Helvetica, Arial, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      color: #2c3e50;
      width: 100%;
      height: 100%;
      position: relative;
      .logo {
        line-height: 60px;
        background-color: #409eff;
        padding: 0 20px;
        position: absolute;
        top: 20px;
        left: 20px;
        z-index: 2000;
        color: #fff;
        font-size: 20px;
        border-radius: 8px;
        width: 460px;
        img {
          width: 90px;
          vertical-align: middle;
          margin-right: 10px;
          margin-bottom: 5px;
        }
      }
      .bottomNum {
        position: absolute;
        width: 100%;
        line-height: 30px;
        bottom: 0;
        left: 0;
        z-index: 2000;
        font-size: 13px;
        img {
          vertical-align: middle;
          height: 35px;
          margin-left: 5px;
        }
      }
      .info {
        display: none;
      }
      @media screen and (max-width: 767px) {
        .logo {
          line-height: 50px;
          height: 50px;
          overflow: hidden;
          font-size: 14px;
          position: fixed;
          top: 0;
          left: 0;
          z-index: 2000;
          width: 100%;
          border-radius: 0;
          text-align: center;
          padding-left: 100px;
          box-sizing: border-box;
          img {
            height: 34px;
            position: absolute;
            top: 8px;left: 20px;z-index: 2;
          }
        }
        .bottomNum {
          position: absolute;
          width: 100%;
          line-height: 20px;
          bottom: 0;
          left: 0;
          z-index: 2000;
          font-size: 13px;
          text-align: center;
          img {
            display: none;
          }
        }
        .info {
          display: block;
          width: 30px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          position: absolute;
          bottom: 20px;
          right: 10px;
          z-index: 2001;
          background-color: #e6a23c;
          color: #fff;
          border-radius: 5px;
          font-size: 18px;
        }
        .msgCont {
          width: 80%;
          height: 50%;
          background-color: #fff;
          box-sizing: border-box;
          box-shadow: 1px 1px 5px rgb(0 0 0 / 30%);
          border-radius: 5px;
          position: absolute;
          left: 50%;
          top: 50%;
          z-index: 20005;
          transform: translate(-50%, -50%);
          h3 {
            box-sizing: border-box;
            padding: 10px;
            font-weight: normal;
            font-size: 16px;
            line-height: 40px;
            padding: 0;
            margin: 0;
            text-align: center;
            position: relative;
            i {
              position: absolute;
              top: 11px;
              right: 10px;
              z-index: 20005;
            }
            &:after {
              content: "";
              width: 100%;
              height: 1px;
              background-image: linear-gradient(
                to right,
                #fff,
                #ccc,
                #ccc,
                #ccc,
                #ccc,
                #ccc,
                #fff
              );
              position: absolute;
              top: 41px;
              left: 0;
              z-index: 3;
            }
          }
          .infoCont {
            position: absolute;
            top: 41px;
            left: 10px;
            right: 10px;
            bottom: 10px;
            z-index: 20005;
            overflow: hidden;
            overflow-y: scroll;
            padding: 10px 5px;
            p {
              padding: 0;
              margin: 0;
              font-size: 14px;
              line-height: 30px;
              margin-bottom: 10px;
            }
          }
        }
      }
    }
  }
}
</style>
